var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleManagerHub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFCC33;}\n\t.st2{fill:#FFCC00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.7,44.8c2.5-0.7,4.7-1.1,6.8-1.1c2.1,0,4.4,0.4,6.8,1.1c2.5,0.7,4.7,1.8,6.8,3.4c2.1,1.6,3.1,3.4,3.1,5.4 v15.9H27.7V53.6c0-2,1-3.8,3.1-5.4C32.9,46.6,35.2,45.5,37.7,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.6,37c-1.7,2-3.7,3-6.1,3c-2.4,0-4.4-1-6.2-3c-1.7-2-2.6-4.4-2.6-7.2c0-2.8,0.9-5.2,2.6-7.2 c1.7-2,3.8-3,6.2-3c2.4,0,4.4,1,6.1,3c1.7,2,2.5,4.4,2.5,7.2C53.1,32.6,52.3,35,50.6,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.3,41.1c-1.2,1.2-2.6,1.9-4.2,1.9c-1.6,0-3-0.6-4.2-1.9c-1.2-1.2-1.8-2.7-1.8-4.4c0-1.7,0.6-3.2,1.8-4.4 c1.2-1.2,2.6-1.9,4.2-1.9c1.6,0,3,0.6,4.2,1.9c1.2,1.2,1.8,2.7,1.8,4.4C68.1,38.4,67.5,39.8,66.3,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,46.4c1.8,0,3.7,0.3,5.8,0.9c2.1,0.6,4,1.5,5.8,2.9c1.8,1.3,1.9,2.8,1.9,4.5v5.9l-11.3,8.1V54.7 c0-3.2-1.3-6-4-8.2C61.7,46.4,62.3,46.4,63.1,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.5,41.1c1.2,1.2,2.6,1.9,4.2,1.9c1.6,0,3-0.6,4.2-1.9c1.2-1.2,1.8-2.7,1.8-4.4c0-1.7-0.6-3.2-1.8-4.4 c-1.2-1.2-2.6-1.9-4.2-1.9c-1.6,0-3,0.6-4.2,1.9c-1.2,1.2-1.8,2.7-1.8,4.4C20.8,38.4,21.4,39.8,22.5,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.9,46.5c-1.8,0-3.7,0.3-5.8,0.9c-2.1,0.6-4,1.6-5.8,2.9c-1.8,1.3-1.9,2.9-1.9,4.6v5.9l11.3,8.1v-14 c0-3.3,1.3-6,4-8.2C27.3,46.5,26.7,46.5,25.9,46.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleManagerHub);
export default __webpack_public_path__ + "static/media/people-manager-hub.6965c79a6f8718a426d5dc91fc8e30d1.svg";
export { ForwardRef as ReactComponent };